import React from 'react';
import OriginationDashboard from '../components/dashboard/OriginationDashboard';

export default function DashboardPage() {
  return <OriginationDashboard />;
}